import {IInsideOrbitMenuServices} from "../../../../services/inside-orbit-menu-services/inside-orbit-menu.service.interface";
import {IInsideOrbitMenuActionInterface} from "../interface/inside-orbit-menu-action.interface";
import {NEW_BUG} from "../../inside-orbit-menu-consts/inside-orbit-menu-text.consts";

export class OpenNewBugAction implements IInsideOrbitMenuActionInterface {
    constructor(private services: IInsideOrbitMenuServices) {}

    get text() {
        return NEW_BUG;
    }

    execute = () =>  {
        this.services.clientTools.openNewBug();
    }
}